export default __webpack_public_path__ + "static/media/mixkit-atm-cash-machine-key-press-2841.6d561f70.wav";